/* Vintage Paris — comportamenti della landing (porting 1:1 dello script inline originale) */

// Hamburger menu
(function () {
  var btn = document.getElementById('vp-hamburger');
  var menu = document.getElementById('vp-mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', function () {
    var isOpen = menu.classList.toggle('vp-open');
    btn.classList.toggle('vp-open', isOpen);
    btn.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
  menu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      menu.classList.remove('vp-open');
      btn.classList.remove('vp-open');
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
})();

// Link "Preferenze cookie" nel footer: riapre il banner cookie nativo di Shopify
document.addEventListener('click', function (e) {
  if (!e.target.closest || !e.target.closest('[data-vp-cookie-prefs]')) return;
  e.preventDefault();
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    window.privacyBanner.showPreferences();
  }
});

// Hero video: avvio al primo tocco su mobile se l'autoplay è bloccato
(function () {
  var v = document.getElementById('vp-hero-bg');
  if (!v) return;
  document.addEventListener('touchstart', function () {
    if (v.paused) v.play().catch(function () {});
  }, { once: true, passive: true });
})();

// Contact form — invio nativo al form contatti di Shopify (mail all'email del negozio).
// Niente invio in background: la protezione anti-spam di Shopify intercetta il submit e reinvia il form da sé,
// un fetch parallelo fallirebbe (errore a schermo) e rischierebbe un doppio invio.
// Al ritorno (?contact_posted=true) il server segna l'esito: si mostra il messaggio e si emette 'vp:lead'.
(function () {
  var form = document.getElementById('vp-contact-form');
  if (!form) return;
  var fb = document.getElementById('vp-form-feedback');
  var btn = document.getElementById('vp-submit');
  var msgOk = fb.getAttribute('data-msg-success');
  var msgKo = fb.getAttribute('data-msg-error');

  function show(text, type) {
    fb.textContent = text;
    fb.className = 'vp-form-feedback vp-' + type;
  }

  var status = fb.getAttribute('data-vp-form-status');
  if (status === 'success') {
    show(msgOk, 'success');
    document.dispatchEvent(new CustomEvent('vp:lead')); // Lead Meta: snippets/vp-meta-eventi.liquid
    if (window.history && history.replaceState) {
      history.replaceState(null, '', location.pathname + location.hash);
    }
    fb.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else if (status === 'error') {
    show(msgKo, 'error');
    fb.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  form.addEventListener('submit', function (e) {
    fb.className = 'vp-form-feedback';

    var nome = document.getElementById('vp-nome').value.trim();
    var cognome = document.getElementById('vp-cognome').value.trim();
    var email = document.getElementById('vp-email').value.trim();
    var msg = document.getElementById('vp-messaggio').value.trim();
    var privacy = document.getElementById('vp-privacy').checked;
    var error = '';

    if (!nome || !cognome || !email || !msg) {
      error = 'Compila tutti i campi obbligatori (*)';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      error = 'Inserisci un indirizzo email valido.';
    } else if (!privacy) {
      error = 'Devi accettare la Privacy Policy per proseguire.';
    }

    if (error) {
      e.preventDefault();
      e.stopImmediatePropagation();
      show(error, 'error');
      return;
    }

    // solo feedback visivo: disabilitare il pulsante può bloccare il reinvio della protezione anti-spam di Shopify
    btn.textContent = 'Invio in corso…';
  }, true);

  // ritorno con il tasto indietro (bfcache): ripristina l'etichetta
  var label = btn.textContent;
  window.addEventListener('pageshow', function () { btn.textContent = label; });
})();
